<template lang='slm'>
  .container.table-responsive
    table.table.table-bordered
      thead
        tr
          th Картинка
          th Аудио
          th Название
          th Спикер
          th Дата
          th Действия
      tbody
        tr v-for='item in items'
          td
            img.preview :src='"/api/file/" + item.imageId'
          td
            audio controls='' preload='none'
              source :src='"/api/file/" + item.fileId' type='audio/mp3'
          td {{ item.title }}
          td {{ item.speaker }}
          td {{ item.date | date }}
          td
            button.btn.btn-info.mr-2 type='button' @click='editItem(item)'
              icon name='pencil-alt'
            button.btn.btn-danger type='button' @click='deleteItem(item)'
              icon name='trash'
    .text-left
      button.btn.btn-success.d-flex type='button' @click='addItem()'
        icon.mr-2 name='plus'
        span Добавить аудио проповедь
    modal ref='modal' @confirm='saveItem' title='Аудиопроповедь'
      admin-audio-preaching-modal-content
</template>

<script>
import Modal from '@/components/Modal';
import gql from 'graphql-tag';
import dateformat from 'dateformat';
import AdminAudioPreachingModalContent from './_AdminAudioPreachingModalContent';

function defaultModalItem() {
  return {
    id: null,
    imageId: null,
    fileId: null,
    title: '',
    speaker: '',
    date: new Date(),
    duration: 0,
  };
}

const ITEM_FIELDS = 'id imageId title speaker date fileId';
const GET_DATA_QUERY = gql`{ audioPreachings { ${ITEM_FIELDS} } }`;

export default {
  name: 'AdminAudioPreachings',
  components: { Modal, AdminAudioPreachingModalContent },
  apollo: {
    data: {
      client: 'admin',
      query: GET_DATA_QUERY,
      update(data) {
        this.items = data.audioPreachings.map(audio => ({
          ...audio,
          date: dateformat(new Date(audio.date), 'yyyy-mm-dd'),
        }));
      },
    },
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    editItem(item) {
      this.$refs.modal.open(item);
    },
    addItem() {
      this.$refs.modal.open(defaultModalItem());
    },
    deleteItem(item) {
      this.$apollo.mutate({
        client: 'admin',
        mutation: gql`mutation DeleteAudioPreaching($id: Int!) { deleteAudioPreaching(id: $id) { id } }`,
        variables: { id: item.id },
        update: (store, { data: { deleteAudioPreaching: { id: deleteItemWithId } } }) => {
          const data = store.readQuery({ query: GET_DATA_QUERY });
          data.audioPreachings = data.audioPreachings
            .filter(audioPreachingItem => audioPreachingItem.id !== deleteItemWithId);
          store.writeQuery({ query: GET_DATA_QUERY, data });
        },
      }).then(() => this.$refs.modal.close());
    },
    saveItem(item) {
      this.$apollo.mutate({
        client: 'admin',
        mutation: gql`mutation SaveAudioPreaching($id: Int, $imageId: Int!, $title: String!, $speaker: String!, $date: Date!, $duration: Int!, $fileId: Int!) {
          saveAudioPreaching(id: $id, imageId: $imageId, title: $title, speaker: $speaker, date: $date, duration: $duration, fileId: $fileId) { ${ITEM_FIELDS} }
        }`,
        variables: {
          ...item,
          date: dateformat(item.date, 'isoDate'),
        },
        update: (store, { data: { saveAudioPreaching: savedItem } }) => {
          const data = store.readQuery({ query: GET_DATA_QUERY });
          const index = data.audioPreachings.findIndex(audioPreaching => audioPreaching.id === savedItem.id);
          if (index === -1) {
            data.audioPreachings.push(savedItem);
          } else {
            data.audioPreachings[index] = savedItem;
          }
          store.writeQuery({ query: GET_DATA_QUERY, data });
        },
      }).then(() => this.$refs.modal.close());
      // FIXME перезагрузить (.load()) соответствующий audio чтобы обновился файл, если он был изменен
    },
  },
};
</script>
